import React from "react";
import DarkModeToggle from "./components/DarkModeToggle";
import "./App.css";

const App = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900">
      <section className="text-center">
        <h1 className="text-4xl font-bold mb-4 text-gray-800 dark:text-white">
          use-dark-switch Demo
        </h1>
        <p className="text-xl text-gray-600 dark:text-gray-300 mb-8">
          Toggle between light and dark mode using the button below.
        </p>
        <DarkModeToggle />
      </section>
    </div>
  );
};

export default App;
